import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/service/auth.service';

export const planningGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasAccess('PLANNING')) {
    return true;
  }
  router.navigate(['/authentication/signin']);
  return false;
};
